import { render, staticRenderFns } from "./realnameAuth.vue?vue&type=template&id=60b9f070&scoped=true&"
import script from "./realnameAuth.vue?vue&type=script&lang=js&"
export * from "./realnameAuth.vue?vue&type=script&lang=js&"
import style0 from "./realnameAuth.vue?vue&type=style&index=0&id=60b9f070&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9f070",
  null
  
)

export default component.exports